import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { authApiSlice } from "./services/auth";
import authReducer from "./features/authSlice";
import { api } from "./services/api";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Default: localStorage

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
};

// Persisted reducer
const persistedAuthReducer = persistReducer(persistConfig, authReducer);

// Configure store
const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    [authApiSlice.reducerPath]: authApiSlice.reducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }).concat(authApiSlice.middleware),
  devTools: true,
});

// Setup listeners
setupListeners(store.dispatch);

// Create persistor
const persistor = persistStore(store);

// Export store, persistor, RootState, and AppDispatch
export { store, persistor };
